import React from "react";

import PlusIcon from "@uui/Plus";
import { isEmpty } from "lodash/fp";

import styled from "@mui/material/styles/styled";

import AutoAnimateContainer from "@rui/AutoAnimateContainer";
import Button, { ButtonProps } from "@rui/Button";
import IconBackground from "@rui/IconBackground";
import { Row } from "@rui/Stack";

export type Suggestion = { id: string; name: string };

export const Suggestion = styled<React.FC<ButtonProps>>((props) => (
  <Button
    {...props}
    variant="outlined"
    endIcon={
      <IconBackground height={24} sx={{ backgroundColor: "shades.ghost.500" }}>
        <PlusIcon sx={{ color: "shades.primary.500" }} />
      </IconBackground>
    }
  />
))(({ theme }) => ({
  borderColor: theme.palette.shades.neutral[150],
  borderRadius: "16px",
  height: "32px",
  width: "fit-content",
  color: theme.palette.shades.neutral[600],
  padding: theme.spacing(0.5, 1, 0.5, 1.5),
  "&:hover": {
    backgroundColor: "#FFF",
  },
}));

const ShareSuggestions = ({
  onSelectSuggestion,
  suggestions,
}: {
  onSelectSuggestion: (entity: Suggestion) => void;
  suggestions: Suggestion[];
}) => (
  <AutoAnimateContainer show={!isEmpty(suggestions)}>
    <Row
      spacing={0.5}
      flexWrap="wrap"
      sx={{ height: "34px", minHeight: "34px", overflow: "hidden" }}
    >
      {suggestions.map((suggestion) => (
        <Suggestion
          key={suggestion.id}
          onClick={() => onSelectSuggestion(suggestion)}
        >
          {suggestion.name}
        </Suggestion>
      ))}
    </Row>
  </AutoAnimateContainer>
);

export default ShareSuggestions;
